import { useQuery } from '@tanstack/react-query';
import { FacetsService } from '../services/facetsService';
import type { Facet } from '../types';

/**
 * Hook compartilhado para listar as facetas da organização via React Query.
 *
 * Por que React Query: o seletor de facetas é montado em formulários (ex.: o
 * diálogo de import) que ficam abertos enquanto a página de Knowledge
 * re-renderiza em alta frequência (eventos SSE de progresso de embedding, um
 * por chunk). Um fetch imperativo em useEffect refazia a chamada a cada
 * re-render/oscilação de dependência, gerando um GET /facets por chunk e
 * fazendo o campo "piscar" no formulário. Com cache + staleTime, re-renders
 * servem os dados do cache instantaneamente, sem rede e sem flicker.
 *
 * O queryKey ['facets', orgId, includeInactive] é o mesmo usado por
 * FacetsSettings, então mutações lá (que invalidam ['facets', orgId])
 * atualizam este cache automaticamente.
 */
export function useFacets(orgId?: string | null, includeInactive = false) {
  return useQuery<Facet[]>({
    queryKey: ['facets', orgId, includeInactive],
    queryFn: () => (orgId ? FacetsService.list(orgId, includeInactive) : Promise.resolve<Facet[]>([])),
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
  });
}
